export default "__VITE_ASSET__C3JD8IJ6__"